import { InfoBox } from '@tryhackme/thm-ui-components';
import styled, { keyframes } from 'styled-components';

export const StyledInfoBox = styled(InfoBox)`
  font-size: ${({ theme }) => `${theme.fonts.sizes.default}`};
`;

export const StyledChartWrapper = styled.div`
  width: 100%;
  min-height: 44rem;
  flex-grow: 1;
`;

const placeHolderShimmer = keyframes` 

  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 0 0;
  }
`;

export const StyledChartSkeleton = styled.div`
  height: 44rem;
  border-radius: 0.5rem;
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.loading.primary},
    ${({ theme }) => theme.colors.loading.secondary},
    ${({ theme }) => theme.colors.loading.primary}
  );
  background-size: 1000px;
  animation: ${placeHolderShimmer} 2s linear infinite;
`;
